module.exports = __webpack_public_path__ + "img/4.c60a0333.jpg";